import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

export default function Preloader() {
  const [show, setShow] = useState(true);
  useEffect(() => {
    const t = setTimeout(() => setShow(false), 1400);
    return () => clearTimeout(t);
  }, []);
  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ y: 0 }}
          exit={{ y: "-100%" }}
          transition={{ duration: 0.8, ease: [0.7, 0, 0.2, 1] }}
          className="fixed inset-0 z-[80] bg-[hsl(var(--primary-dark))] text-white flex flex-col items-center justify-center"
          data-testid="preloader"
        >
          <motion.div
            initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}
          >
            <img src="/assets/logo.png" alt="Calm Dentistry & Cosmetology" className="h-16 md:h-20 w-auto brightness-0 invert" />
          </motion.div>
          <motion.div
            initial={{ scaleX: 0 }} animate={{ scaleX: 1 }} transition={{ duration: 0.9, delay: 0.2 }}
            className="mt-6 h-[2px] w-40 bg-white/60 origin-left"
          />
          <div className="mt-4 text-[12px] uppercase tracking-widest text-white/60">Gentle ways in dental care</div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
